import * as React from 'react';
import type { FieldProps, SelectProps } from '@fluentui/react-components';
import { Field, makeStyles, Select as FluentSelect, tokens } from '@fluentui/react-components';

export function SelectField({
  label,
  hint,
  defaultValue,
  onChange,
  placeholder,
  validationMessage,
  validationState,
  required,
  children,
  disabled,
  className,
}: Omit<FieldProps, 'onChange' | 'children'> & SelectProps) {
  const classes = useStyles();
  return (
    <Field
      required={required}
      label={label}
      validationMessage={validationMessage}
      validationState={validationState}
      hint={hint}
      className={className}
    >
      <FluentSelect
        className={defaultValue === '' ? classes.root : undefined}
        required={required}
        defaultValue={defaultValue}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
      >
        {children}
      </FluentSelect>
    </Field>
  );
}

const useStyles = makeStyles({
  root: {
    '& select': {
      color: '#717171',
    },
    '& select option': {
      color: tokens.colorNeutralForeground1,
    },
    '& select option:disabled': {
      color: '#717171',
    },
  },
});
